import http from '@/utils/http'
export const getProject = data => http.get('/user-center/api/project', {
    params: data
})
export const addProject = data => http.post('/user-center/api/project', data)
export const editProject = data => http.put('/user-center/api/project', data)
export const delProgect = data => http.delete('/user-center/api/project', {
    params: data
})
export const findProjectMachine = data => http.get('/user-center/api/project/machine', {
    params: data
})
export const editProjectMachine = data => http.put('/user-center/api/project/machine', data)
export const delProjectMachine = data => http.put('/user-center/api/project/machine', data)
export const getMachineId = data => http.get('/user-center/api/project/machinelist', {
    params: data
})
export const updateNMachine = data => http.get('/rvm-center/api/machine/project/notice', {
    params: data
})


export const updateNReject = data => http.get('/kg-analysis/api/reject/project/notice', {
    params: data
})
export const updateNmaintance = data => http.get('/maintenance-center/api/cleanrecord/project/notice', {
    params: data
})
export const updateNFile = data => http.get('/file-center/api/ad/template/project/notice', {
    params: data
})
export const updateNPay = data => http.get('/kg-payment/api/dof/transaction/project/notice', {
    params: data
})
export const updateNNotice = data => http.get('/kg-notification/api/error/email/project/notice', {
    params: data
})
export default {
    getProject,
    addProject,
    editProject,
    delProgect,
    findProjectMachine,
    editProjectMachine,
    getMachineId,
    updateNMachine,
    updateNReject,
    updateNmaintance,
    updateNFile,
    updateNPay,
    updateNNotice
}